import { render, staticRenderFns } from "./CohortSubpage.vue?vue&type=template&id=2e00c0c1&"
import script from "./CohortSubpage.vue?vue&type=script&lang=js&"
export * from "./CohortSubpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports